import axios from "axios"
import { clearLocalStorage } from "../utils"
import { authHeader } from "../helpers/auth-header"
import store from "../store"
import { logoutClearStore, logoutUser, logoutUserAction } from "../actions/userActions"
import { clearMultibase } from "../actions/multiAiBase"

export const clienteAxios = axios.create({
	baseURL: window._env_.REACT_APP_API_URL,
	headers: {
		common: authHeader(),
	},
})

clienteAxios.interceptors.response.use(
	(response) => {
		return response
	},
	async (error) => {
		const status = error?.response?.status
		if (status === 403 || status === 401) {
			store?.dispatch(logoutClearStore())
			//store?.dispatch(logoutUserAction())  //commenting this for now, It will be taken when refresh token is implemented
			store?.dispatch(logoutUser())
			clearLocalStorage()
			store?.dispatch(clearMultibase())
			return
		}
		return Promise.reject(error)
	}
)

export function updateHeader() {
	clienteAxios.defaults.headers.common = authHeader()
}

export default clienteAxios
